import Gmap from './components/Gmap'
import GmapGeojson from './components/GmapGeojson'
import GmapHeat from './components/GmapHeat'
import GmapKml from './components/GmapKml'
import GmapMarker from './components/GmapMarker'
import GmapMarkers from './components/GmapMarkers'
import GmapStatic from './components/GmapStatic'

import './style.css'

const addGmapScript = (key = '', libraries = []) => {
  const script = document.createElement('script')
  script.src = `https://maps.googleapis.com/maps/api/js?key=${key}&libraries=${libraries.join(',')}`
  document.body.appendChild(script)
}

export default {
  install (Vue, options = {}) {
    addGmapScript(options.key, options.libraries)
    Vue.$bvueGmapKey = options.key
    Vue.$bvueGmapDefaults = options.defaults || {}
    Vue.component('bvueGmap', Gmap)
    Vue.component('bvueGmapGeojson', GmapGeojson)
    Vue.component('bvueGmapHeat', GmapHeat)
    Vue.component('bvueGmapKml', GmapKml)
    Vue.component('bvueGmapMarker', GmapMarker)
    Vue.component('bvueGmapMarkers', GmapMarkers)
    Vue.component('bvueGmapStatic', GmapStatic)
  }
}



// WEBPACK FOOTER //
// ./src/plugin/index.js